var map = {
	"./1": 145,
	"./1.png": 145,
	"./2": 146,
	"./2.png": 146,
	"./3": 147,
	"./3.png": 147,
	"./4": 148,
	"./4.png": 148,
	"./about": 149,
	"./about.png": 149,
	"./activity": 249,
	"./activity.svg": 249,
	"./add-cta": 331,
	"./add-cta-active": 332,
	"./add-cta-active.svg": 332,
	"./add-cta.svg": 331,
	"./added-to-collections-active": 333,
	"./added-to-collections-active.svg": 333,
	"./adobe": 150,
	"./adobe.png": 150,
	"./analytics": 334,
	"./analytics.svg": 334,
	"./annotate": 335,
	"./annotate-active": 336,
	"./annotate-active.svg": 336,
	"./annotate.svg": 335,
	"./annotate/arrow": 292,
	"./annotate/arrow.svg": 292,
	"./annotate/crop": 293,
	"./annotate/crop.svg": 293,
	"./annotate/draw": 294,
	"./annotate/draw.svg": 294,
	"./annotate/ellipse": 295,
	"./annotate/ellipse-focus": 296,
	"./annotate/ellipse-focus.svg": 296,
	"./annotate/ellipse.svg": 295,
	"./annotate/emoji": 130,
	"./annotate/emoji.png": 130,
	"./annotate/emoji@2x": 131,
	"./annotate/emoji@2x.png": 131,
	"./annotate/emoji@3x": 132,
	"./annotate/emoji@3x.png": 132,
	"./annotate/highlighter": 297,
	"./annotate/highlighter.svg": 297,
	"./annotate/line": 298,
	"./annotate/line.svg": 298,
	"./annotate/number": 299,
	"./annotate/number.svg": 299,
	"./annotate/pixelate": 300,
	"./annotate/pixelate.svg": 300,
	"./annotate/rect": 301,
	"./annotate/rect.svg": 301,
	"./annotate/square-focus": 302,
	"./annotate/square-focus.svg": 302,
	"./annotate/text": 303,
	"./annotate/text.svg": 303,
	"./annotate/tools-history-back": 304,
	"./annotate/tools-history-back-disabled": 305,
	"./annotate/tools-history-back-disabled.svg": 305,
	"./annotate/tools-history-back.svg": 304,
	"./annotate/tools-history-forward": 306,
	"./annotate/tools-history-forward-disabled": 307,
	"./annotate/tools-history-forward-disabled.svg": 307,
	"./annotate/tools-history-forward.svg": 306,
	"./annotate/tools-zoom-zoom-in": 288,
	"./annotate/tools-zoom-zoom-in.svg": 288,
	"./annotate/tools-zoom-zoom-out": 289,
	"./annotate/tools-zoom-zoom-out.svg": 289,
	"./app-icon": 337,
	"./app-icon.svg": 337,
	"./apple": 338,
	"./apple.svg": 338,
	"./apple_logo": 234,
	"./apple_logo.svg": 234,
	"./arrow-big": 151,
	"./arrow-big.png": 151,
	"./atlassian": 152,
	"./atlassian.png": 152,
	"./bg-bottom": 153,
	"./bg-bottom.png": 153,
	"./bg-top": 154,
	"./bg-top.png": 154,
	"./bill": 339,
	"./bill.svg": 339,
	"./blurred-drop": 96,
	"./blurred-drop.png": 96,
	"./branding": 290,
	"./branding.svg": 290,
	"./buttons-add-new-collection-hover": 340,
	"./buttons-add-new-collection-hover.svg": 340,
	"./buttons-add-new-collection-sidebar": 341,
	"./buttons-add-new-collection-sidebar.svg": 341,
	"./card-generic": 120,
	"./card-generic.png": 120,
	"./check-mark": 342,
	"./check-mark.svg": 342,
	"./checkmark": 343,
	"./checkmark.svg": 343,
	"./checkmark@2x": 155,
	"./checkmark@2x.png": 155,
	"./chrome": 344,
	"./chrome.svg": 344,
	"./close": 310,
	"./close.svg": 310,
	"./cloud-loader": 272,
	"./cloud-loader.gif": 272,
	"./cloudapp": 104,
	"./cloudapp-favicon": 156,
	"./cloudapp-favicon.png": 156,
	"./cloudapp-icon": 157,
	"./cloudapp-icon.png": 157,
	"./cloudapp-logo-horizontal": 224,
	"./cloudapp-logo-horizontal.svg": 224,
	"./cloudapp.png": 104,
	"./coach-mark": 345,
	"./coach-mark.svg": 345,
	"./collection": 225,
	"./collection.svg": 225,
	"./conversation": 346,
	"./conversation.svg": 346,
	"./dashboard": 250,
	"./dashboard.svg": 250,
	"./download-arrow": 347,
	"./download-arrow.svg": 347,
	"./download-chrome": 348,
	"./download-chrome.svg": 348,
	"./download-cloud": 349,
	"./download-cloud.svg": 349,
	"./download-drop": 350,
	"./download-drop.svg": 350,
	"./download-mac": 351,
	"./download-mac.svg": 351,
	"./download-windows": 352,
	"./download-windows.svg": 352,
	"./download_icon_chrome": 353,
	"./download_icon_chrome.svg": 353,
	"./download_icon_mac": 354,
	"./download_icon_mac.svg": 354,
	"./download_icon_windows": 355,
	"./download_icon_windows.svg": 355,
	"./email": 235,
	"./email.svg": 235,
	"./enterprise@2x": 158,
	"./enterprise@2x.png": 158,
	"./file-placeholder": 308,
	"./file-placeholder.svg": 308,
	"./free@2x": 159,
	"./free@2x.png": 159,
	"./free_plan_icon": 160,
	"./free_plan_icon.png": 160,
	"./gift": 273,
	"./gift.svg": 273,
	"./google_logo": 356,
	"./google_logo.svg": 356,
	"./hat-icon": 357,
	"./hat-icon.svg": 357,
	"./hero-asset": 105,
	"./hero-asset.gif": 544,
	"./hero-asset.png": 105,
	"./icon-clock": 236,
	"./icon-clock.jpeg": 236,
	"./icon-get-cloudapp": 202,
	"./icon-get-cloudapp.svg": 202,
	"./icon-google": 237,
	"./icon-google.svg": 237,
	"./icon-muted": 309,
	"./icon-muted.svg": 309,
	"./icon-muted@2x": 161,
	"./icon-muted@2x.png": 161,
	"./icon-padlock": 203,
	"./icon-padlock.svg": 203,
	"./icons-add": 274,
	"./icons-add-bordered": 162,
	"./icons-add-bordered.png": 162,
	"./icons-add-to-collection-solid": 358,
	"./icons-add-to-collection-solid.svg": 358,
	"./icons-add.svg": 274,
	"./icons-announcement": 359,
	"./icons-announcement.svg": 359,
	"./icons-bug": 360,
	"./icons-bug.svg": 360,
	"./icons-card-actions-compact-read-only": 121,
	"./icons-card-actions-compact-read-only.svg": 121,
	"./icons-clipboard": 259,
	"./icons-clipboard.svg": 259,
	"./icons-close": 287,
	"./icons-close.svg": 287,
	"./icons-conversation": 127,
	"./icons-conversation.svg": 127,
	"./icons-download-bordered": 163,
	"./icons-download-bordered.png": 163,
	"./icons-download-solid": 361,
	"./icons-download-solid.svg": 361,
	"./icons-edit-minimal": 238,
	"./icons-edit-minimal.svg": 238,
	"./icons-embed-bordered": 164,
	"./icons-embed-bordered.png": 164,
	"./icons-embed-solid": 362,
	"./icons-embed-solid.svg": 362,
	"./icons-hidden": 363,
	"./icons-hidden.svg": 363,
	"./icons-invite-active": 251,
	"./icons-invite-active.svg": 251,
	"./icons-invite-default": 252,
	"./icons-invite-default.svg": 252,
	"./icons-locked-bordered": 165,
	"./icons-locked-bordered.png": 165,
	"./icons-magic": 364,
	"./icons-magic.svg": 364,
	"./icons-mouse-click": 365,
	"./icons-mouse-click-gray": 366,
	"./icons-mouse-click-gray.svg": 366,
	"./icons-mouse-click.svg": 365,
	"./icons-new": 166,
	"./icons-new-gray": 275,
	"./icons-new-gray.svg": 275,
	"./icons-new-transparent": 276,
	"./icons-new-transparent.svg": 276,
	"./icons-new-white": 277,
	"./icons-new-white.svg": 277,
	"./icons-new.svg": 166,
	"./icons-notifications": 128,
	"./icons-notifications-active": 129,
	"./icons-notifications-active.svg": 129,
	"./icons-notifications.svg": 128,
	"./icons-premium-star": 278,
	"./icons-premium-star.svg": 278,
	"./icons-rainbow-circle": 167,
	"./icons-rainbow-circle.png": 167,
	"./icons-rounded-corners": 367,
	"./icons-rounded-corners.svg": 367,
	"./icons-sales": 368,
	"./icons-sales.svg": 368,
	"./icons-search": 369,
	"./icons-search.svg": 369,
	"./icons-settings-blue": 279,
	"./icons-settings-blue.svg": 279,
	"./icons-settings-gray": 239,
	"./icons-settings-gray.svg": 239,
	"./icons-share-settings-locked": 370,
	"./icons-share-settings-locked.svg": 370,
	"./icons-slightly-rounded-corners": 371,
	"./icons-slightly-rounded-corners.svg": 371,
	"./icons-square-corners": 372,
	"./icons-square-corners.svg": 372,
	"./icons-support": 373,
	"./icons-support.svg": 373,
	"./icons-toggle-close": 280,
	"./icons-toggle-close.svg": 280,
	"./icons-toggle-open": 281,
	"./icons-toggle-open.svg": 281,
	"./icons-transcribe": 240,
	"./icons-transcribe.svg": 240,
	"./illustrations-transcription-processing": 282,
	"./illustrations-transcription-processing.svg": 282,
	"./indicator-right": 374,
	"./indicator-right.svg": 374,
	"./infinite": 291,
	"./infinite.svg": 291,
	"./installer": 375,
	"./installer.svg": 375,
	"./logo-visa": 376,
	"./logo-visa.jpeg": 376,
	"./logo@2x": 110,
	"./logo@2x-blue": 168,
	"./logo@2x-blue.png": 168,
	"./logo@2x.png": 110,
	"./logos-cloud-app-logomark-full-color": 241,
	"./logos-cloud-app-logomark-full-color.svg": 241,
	"./main-banner": 169,
	"./main-banner.png": 169,
	"./menu-bar": 377,
	"./menu-bar.svg": 377,
	"./onboarding/apple": 204,
	"./onboarding/apple.svg": 204,
	"./onboarding/bill": 170,
	"./onboarding/bill.svg": 170,
	"./onboarding/chrome": 205,
	"./onboarding/chrome.svg": 205,
	"./onboarding/download-arrow": 206,
	"./onboarding/download-arrow.svg": 206,
	"./onboarding/download-chrome": 207,
	"./onboarding/download-chrome.svg": 207,
	"./onboarding/download-drop": 208,
	"./onboarding/download-drop.svg": 208,
	"./onboarding/download-mac": 209,
	"./onboarding/download-mac.svg": 209,
	"./onboarding/download-windows_color": 210,
	"./onboarding/download-windows_color.svg": 210,
	"./onboarding/email": 171,
	"./onboarding/email.svg": 171,
	"./onboarding/hat-icon": 211,
	"./onboarding/hat-icon.svg": 211,
	"./onboarding/icons-check": 122,
	"./onboarding/icons-check.svg": 122,
	"./onboarding/icons-chrome": 212,
	"./onboarding/icons-chrome.svg": 212,
	"./onboarding/icons-download": 172,
	"./onboarding/icons-download.svg": 172,
	"./onboarding/icons-extension": 173,
	"./onboarding/icons-extension.svg": 173,
	"./onboarding/icons-mac-os-app": 106,
	"./onboarding/icons-mac-os-app.png": 106,
	"./onboarding/icons-record": 174,
	"./onboarding/icons-record.svg": 174,
	"./onboarding/in-browser-icon": 213,
	"./onboarding/in-browser-icon.svg": 213,
	"./onboarding/installer": 214,
	"./onboarding/installer.svg": 214,
	"./onboarding/menu-bar": 215,
	"./onboarding/menu-bar.svg": 215,
	"./onboarding/start": 175,
	"./onboarding/start.svg": 175,
	"./onboarding/windows": 216,
	"./onboarding/windows.svg": 216,
	"./parallax": 378,
	"./parallax.jpg": 378,
	"./pattern": 176,
	"./pattern-2": 177,
	"./pattern-2.png": 177,
	"./pattern-4": 178,
	"./pattern-4.png": 178,
	"./pattern.png": 176,
	"./plus": 379,
	"./plus-small": 380,
	"./plus-small.svg": 380,
	"./plus.svg": 379,
	"./prize": 381,
	"./prize.svg": 381,
	"./prize@2x": 111,
	"./prize@2x.png": 111,
	"./pro-badge": 217,
	"./pro-badge.svg": 217,
	"./pro-ribbon": 87,
	"./pro-ribbon.png": 87,
	"./pro-ribbon.svg": 545,
	"./pro@1x": 179,
	"./pro@1x.png": 179,
	"./pro@2x": 123,
	"./pro@2x.png": 123,
	"./pro@3x": 180,
	"./pro@3x.png": 180,
	"./pro_plan_icon": 181,
	"./pro_plan_icon.png": 181,
	"./salesforce": 182,
	"./salesforce.png": 182,
	"./seats-left": 382,
	"./seats-left.svg": 382,
	"./slack-icon": 183,
	"./slack-icon.png": 183,
	"./slack_logo": 242,
	"./slack_logo.svg": 242,
	"./social-proof-image": 243,
	"./social-proof-image.jpeg": 243,
	"./spinner": 65,
	"./spinner.svg": 65,
	"./star_active": 383,
	"./star_active.svg": 383,
	"./star_default": 384,
	"./star_default.svg": 384,
	"./star_hover": 385,
	"./star_hover.svg": 385,
	"./start": 386,
	"./start.svg": 386,
	"./team": 244,
	"./team-3": 387,
	"./team-3.jpg": 387,
	"./team.svg": 244,
	"./team@2x": 124,
	"./team@2x.png": 124,
	"./team_plan_icon": 133,
	"./team_plan_icon.png": 133,
	"./team_sidebar": 184,
	"./team_sidebar.png": 184,
	"./thumbnail": 185,
	"./thumbnail.png": 185,
	"./upload-arrow": 388,
	"./upload-arrow.svg": 388,
	"./upload-cloud": 389,
	"./upload-cloud.svg": 389,
	"./upload-copy": 186,
	"./upload-copy.png": 186,
	"./upload-copy@2x": 187,
	"./upload-copy@2x.png": 187,
	"./upload-copy@3x": 188,
	"./upload-copy@3x.png": 188,
	"./upload-drop": 390,
	"./upload-drop.svg": 390,
	"./video-thumbnail": 189,
	"./video-thumbnail.png": 189,
	"./video-trim": 391,
	"./video-trim-active": 392,
	"./video-trim-active.svg": 392,
	"./video-trim.svg": 391,
	"./view-grid": 393,
	"./view-grid-active": 394,
	"./view-grid-active.svg": 394,
	"./view-grid.svg": 393,
	"./view-list": 395,
	"./view-list-active": 396,
	"./view-list-active.svg": 396,
	"./view-list.svg": 395,
	"./windows": 397,
	"./windows.svg": 397,
	"./your_plan_badge@2x": 190,
	"./your_plan_badge@2x.png": 190,
	"./zendesk": 191,
	"./zendesk.png": 191
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 493;